import { render, staticRenderFns } from "./feesbreakdown.vue?vue&type=template&id=bbcb069a&"
import script from "./feesbreakdown.vue?vue&type=script&lang=js&"
export * from "./feesbreakdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports